// class PredictiveSearch extends HTMLElement{constructor(){super()}connectedCallback(){this.form=this.querySelector("form"),this.clear_button=this.querySelector(".search--clear"),this.input=this.querySelector(".search--textbox"),this.results=this.querySelector(".search--results"),this.cached_results={"":this.results.innerHTML},this.listenForKeyEntered(),this.formSubmit(),this.clearButtonListener(),this.addMutationObserver()}listenForKeyEntered(){this.input.on("input",()=>{var t=this.input.value.trim();this.clear_button.style.display=""===t?"none":"flex",this.getSearchResults(t)})}async getSearchResults(t){this.abort_controller&&this.abort_controller.abort();var e=t.handleize();if(this.cached_results[e])this.results.innerHTML=this.cached_results[e];else{this.abort_controller=new AbortController,this.toggleLoading(!0);try{var r=await fetch(`${theme.urls.predictive_search}?q=${encodeURIComponent(t)}&section_id=predictive-search`,{signal:this.abort_controller.signal});if(!r.ok)throw new Error(r.status);var s=await r.text(),i=theme.utils.parseHtml(s).innerHTML;this.cached_results[e]=i,this.results.innerHTML=i}catch{}}}clearButtonListener(){this.clear_button.on("click keydown",t=>{"keydown"===t.type&&"Enter"!==t.key||(t.preventDefault(),this.input.value="",this.input.focus(),this.input.trigger("input"))})}toggleLoading(t){setTimeout(()=>this.setAttribute("data-loading",t),t?0:100)}formSubmit(){this.form.on("submit",t=>{t.preventDefault(),window.location.href=theme.urls.search+"?type=product&q="+encodeURIComponent(this.input.value.trim())})}addMutationObserver(){new MutationObserver(()=>{this.toggleLoading(!1),window.trigger("theme:search:reloaded"),theme.transitions.reload("search")}).observe(this.results,{childList:!0})}}customElements.define("predictive-search-root",PredictiveSearch);

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.clear_button = this.querySelector(".search--clear");
    this.input = this.querySelector(".search--textbox");
    this.results = this.querySelector(".search--results");
    this.cached_results = { "": this.results.innerHTML };
    this.search_tag = this.querySelector("#search-tag"); // Get the select element for search tag
    this.listenForKeyEntered();
    this.listenForEnterKey();
    this.listenForTagChange(); // Listen for tag change
    this.formSubmit();
    this.clearButtonListener();
    this.addMutationObserver();
  }

  listenForKeyEntered() {
    this.input.addEventListener("input", () => {
      var t = this.input.value.trim();
      this.clear_button.style.display = t === "" ? "none" : "flex";
      this.getSearchResults(t); // Get search results as user types
    });
  }

  listenForEnterKey() {
    this.input.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent default form submission

        const searchText = this.input.value.trim(); // Get input value
        const selectedOption = document.querySelector(
          ".ss-list .ss-option-selected"
        ); // Get selected option

        if (selectedOption) {
          const selectedValue = selectedOption.textContent.trim(); // Get selected option text

          if (selectedValue.toUpperCase() === "ALL") {
            window.location.href =
              theme.urls.search +
              "?type=product&q=" +
              encodeURIComponent(searchText + "*");
          } else {
            // Construct search query with selected option and `*`
            const query = `tag:"${encodeURIComponent(
              selectedValue
            )}" AND ${encodeURIComponent(searchText)}*`;
            window.location.href =
              theme.urls.search + "?type=product&q=" + query;
          }
        }
      }
    });
  }

  listenForTagChange() {
    this.search_tag.addEventListener("change", () => {
      const query = this.input.value.trim();
      this.getSearchResults(query);
    });
  }

  async getSearchResults(query) {
    const selectedTag = this.search_tag.value.trim(); // Trim any extra spaces
    let url;

    if (selectedTag === "all") {
      url = `${theme.urls.predictive_search}?q=${encodeURIComponent(
        query
      )}&section_id=predictive-search`;
    } else {
      // Properly encode multi-word tags by wrapping them in quotes
      const encodedTag = `"${encodeURIComponent(selectedTag)}"`;
      url = `${
        theme.urls.predictive_search
      }?q=tag:${encodedTag} AND ${encodeURIComponent(
        query
      )}&resources[limit]=4&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
    }

    if (this.abort_controller) this.abort_controller.abort();

    this.abort_controller = new AbortController();
    this.toggleLoading(true);
    try {
      const response = await fetch(url, {
        signal: this.abort_controller.signal,
      });
      if (!response.ok) throw new Error(response.status);
      const html = await response.text();
      const parsedHtml = theme.utils.parseHtml(html).innerHTML;
      this.results.innerHTML = parsedHtml;
    } catch (error) {
      console.error(error);
    }
  }

  clearButtonListener() {
    this.clear_button.addEventListener("click", (event) => {
      event.preventDefault();
      this.input.value = "";
      this.input.focus();
      this.clear_button.style.display = "none";
      this.results.innerHTML = "";
    });
  }

  toggleLoading(isLoading) {
    setTimeout(
      () => this.setAttribute("data-loading", isLoading),
      isLoading ? 0 : 100
    );
  }

  formSubmit() {
    this.form.addEventListener("submit", (event) => {
      event.preventDefault();
      const query = this.input.value.trim();
      const selectedTag = this.search_tag.value.trim();
      let searchUrl = `${theme.urls.search}?type=product&q=${encodeURIComponent(
        query
      )}&resources[limit]=4`;

      if (selectedTag !== "all") {
        // Wrap the tag in double quotes for multi-word tag support
        const encodedTag = `"${encodeURIComponent(selectedTag)}"`;
        searchUrl = `${
          theme.urls.predictive_search
        }?q=tag:${encodedTag} AND ${encodeURIComponent(
          query
        )}&resources[limit]=4&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
      }

      window.location.href = searchUrl;
    });
  }

  addMutationObserver() {
    new MutationObserver(() => {
      this.toggleLoading(false);
      window.trigger("theme:search:reloaded");
      theme.transitions.reload("search");
    }).observe(this.results, { childList: true });
  }
}

customElements.define("predictive-search-root", PredictiveSearch);
